<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition-upper', 'pa-connection-message-modal-view-modal']"
   :additionalZIndex="2"
   :isOpen="isOpenModal"
   :position="{top: .1}"
   :isFreez="isFreezModal"
   contentTransitionName="trans-content"

   @closeOverlayModal="handleCloseOverlay"
   @afterEnterContent="handleAfterEnterContent"
  >
    <div class="pa-wide-modal-box-wrapper pa-pod-message-modal-view">
      <div class="pa-wide-modal-box">
        <PodMessage
         :id="podMessageId"
         :isModalView="true"
         :isCustomErrorHandling="true"
         
         @handleLoadError="handleLoadMessageError"
        />
        <div class="pa-modal-close-button-wrap">
          <button
          class="pa-modal-close-button"
          @click.prevent="handleCloseModal"
          >閉じる</button>
        </div>
      </div>
    </div>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PodMessage     from '@/components/Pages/Connections/ConnectionApp/components/PodMessage/PodMessage.vue'

export default {
  components : {
    PaOverlayModal,
    PodMessage
  },

  data(){
    return {
      podMessageId  : null,
      isOpenModal   : false,
      isFreezModal  : false,
    };
  },

  computed : {
    urlQuery(){
      return this.$route.query;
    },

    selectedPodType(){
      return this.$route.params.roomType;
    }
  },

  watch : {
    urlQuery : {
      handler(data){
        if(typeof data !== 'object') return;

        if(typeof data.pod_message_id === 'undefined'){
          this.podMessageId = null;
        }else{
          this.podMessageId = data.pod_message_id;
        }
      },
      immediate: true,
      deep: true
    },

    podMessageId : {
      handler(value){
        if(typeof value === 'undefined') return;
        if(value === null) return;

        if(this.isOpenModal === false){
          // nextTickだと動かないので
          setTimeout(() => {
            this.isOpenModal = true;
          }, 1000);
        }
      },
      immediate: true
    }
  },

  methods : {
    handleCloseOverlay(){
    },

    handleCloseModal(){
      this.isOpenModal = false;

      this.$router.replace({
        name    : 'connections.room',
        params  : {
          roomType: this.selectedPodType
        }
      });
    },

    handleAfterEnterContent(){
    },

    handleLoadMessageError(errorSet){
      this.$nextTick(() => {
        if(errorSet.success === false){
          this.isOpenModal = false;

          this.$router.replace({
            name    : 'connections.room',
            params  : {
              roomType: this.selectedPodType
            }
          });

          this.$store.dispatch({
            type        : 'flashMessage/updateFlashMessage',
            hasMessage  : true,
            message     : '&nbsp;このメッセージは削除されています。',
            status      : 'error',
            hasControl  : true,
            autoClose   : 8000
          }, {root:true});
        }
      });
    }
  },

  mounted(){
    setTimeout(() => {
      if(this.podMessageId !== null){
        this.isOpenModal = true;
      }
    }, 2000);
  }
}
</script>

<style lang="scss">
.pa-pod-message-modal-view{
  .pa-wide-modal-box{
    padding:1rem 0;
    overflow-x: hidden;
    overflow-y: scroll;
    max-height:500px;
    border:0;
    background-color: inherit;

    .pa-connection-pod-message-box{
      width:98%;
      margin:0 auto;

      .pa-character-icon{
        width:100%;
        height: 100%;
        margin: inherit;
        font-size: 1.5rem;
      }

      ul.reply-list{
        padding-bottom:1rem;
        .pa-connections-reply-box{
          ul.controls{
            .pa-character-icon{
              width: 30px;
              height: 30px;
              margin:0;
            }
          }
        }
      }
    }

    .pa-modal-close-button-wrap{
      width:90%;
      margin:.5rem auto 0;

      button.pa-modal-close-button{
        box-sizing: border-box;
        width:100%;
        background-color: #B99264;
        color: #5f4634;
        border:0;
        border-radius: 10px;
        font-size: 1.2rem;
      }
    }
  }
}
</style>